import { ElementNode, $createTextNode } from 'lexical';

export class HighlightNode extends ElementNode {
  __color;

  // eslint-disable-next-line default-param-last
  constructor(color = '#FFFF00', nodeKey) {
    // Provide default color so constructor can be called without arguments
    super(nodeKey);
    this.__color = color;
  }

  static getType() {
    return 'highlight';
  }

  static clone(node) {
    return new HighlightNode(node.__color, node.__key);
  }

  static importJSON(serializedNode) {
    // eslint-disable-next-line no-use-before-define
    const node = $createHighlightNode('', serializedNode.color);
    // Lexical will handle importing children if they exist
    return node;
  }

  exportJSON() {
    const json = {
      type: 'highlight',
      version: 1,
      color: this.__color,
    };

    // Lexical will handle serializing children
    const children = this.getChildren();
    if (children.length > 0) {
      // Let Lexical handle the serialization
      // eslint-disable-next-line no-underscore-dangle
      json.children = children.map((child) => child.exportJSON());
    } else {
      json.children = [];
    }

    return json;
  }

  createDOM() {
    const span = document.createElement('span');
    span.style.backgroundColor = this.__color;
    return span;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__color !== this.__color) {
      // eslint-disable-next-line no-param-reassign
      dom.style.backgroundColor = this.__color;
    }
    return false;
  }

  getHighlightColor() {
    return this.__color;
  }

  setHighlightColor(color) {
    const writable = this.getWritable();
    writable.__color = color;
  }
}

// Factory function
export function $createHighlightNode(text = '', color = '#FFFF00') {
  const node = new HighlightNode(color);
  if (text) {
    node.append($createTextNode(text));
  }
  return node;
}

export function $isHighlightNode(node) {
  return node instanceof HighlightNode;
}
